import React from "react";

const SystemSettings = () => {
    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">System Settings</h5>
                            <button className="btn btn-primary btn-sm">
                                Save Changes
                            </button>
                        </div>

                        <div className="card-body">
                            <div className="text-center text-muted py-5">
                                <h6>Settings not configured</h6>
                                <p className="mb-0">
                                    School profile, branding, academic defaults, and integrations will be managed here.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default SystemSettings;
